import gql from 'graphql-tag';

export const getSurveysValidation = gql`
  query getSurveyValidation {
    externalSettings {
      surveyConfig {
        pendingSurveys
        hasRequired
        blockedDate
        daysToBlock
      }
    }
  }
`;
